import React from 'react';

function FavoriteStar({ filled, onClick }) {
  return (
    <button
      className={`star-btn ${filled ? 'filled' : ''}`}
      title={filled ? 'Remove from favorites' : 'Add to favorites'}
      onClick={onClick}
    >
      {filled ? '★' : '☆'}
    </button>
  );
}

export default FavoriteStar;


